export const OPEN_MAINMENU = 'OPEN_MAINMENU';
export const CLOSE_MAINMENU = 'CLOSE_MAINMENU';
export const TOGGLE_MAINMENU = 'TOGGLE_MAINMENU';
export function setMainMenu(isOpen) {
    return {
        type: isOpen ? OPEN_MAINMENU : CLOSE_MAINMENU,
    };
}
export function toggleMainMenu() {
    return {
        type: TOGGLE_MAINMENU,
    };
}
export function closeMainMenu() {
    return {
        type: CLOSE_MAINMENU,
    };
}
